export { attr, belongsTo, buildSchema, default, hasMany, instantiateRecord, modelFor, teardownRecord } from '@warp-drive/legacy/model';
